import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";
import { BadgeDTO } from "utils/helpers/models/badge/badge.dto";

export const BADGE_APIS = {
  createBadge: (body: BadgeDTO) => postRequest(`/badge`, body),
  getBadges: (params: any) => getRequest("/badge/admin/paginated", params),
  toggleStatus: (badgeId: number) => postRequest(`/badge/${badgeId}/toggle/status`, {}),
  getAllCoreConcept: (params: any) => getRequest("/core-concepts", params),
  updateCoreConcept: ( id: number, params: any) => patchRequest(`/core-concepts/${id}`, params),
};
